import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { List, Row } from '../../../components/List';
import { Edit, Times } from '../../../components/Icon';
import { setCompanyProperty } from '../actions';
import { selectWorks } from '../../Api/selectors';
import { getPropByName } from '../../../utils/props';
import { REQUEST_USER } from '../../Users/constants';
import { REQUEST_COMPANY_PROPERTY_UPDATE } from '../constants';
import { selectUser } from '../../Users/selectors';
import { fetchUser } from '../../Users/actions';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { Textarea } from '../../../components/Textarea';

import styles from './CardRemarks.module.css';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';

dayjs.extend(customParseFormat);
const Container = styled.div`
  font-size: 14px;

  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }

  .icon-cross {
    cursor: pointer;
    font-size: 18px;
    width: 20px;
    height: 22px;
  }

  .icon-edit-square {
    color: #0183d5;
  }

  .fa-square-xmark {
    padding: 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;

    background-color: #d50046;
    color: #fff;
  }

  align-items: center;

  .remark {
    margin-bottom: 10px;
    min-height: 60px;

    .initials-wrapper {
      width: 40px;
      height: 40px;
      background-color: rgba(29, 155, 209, 0.1);
      justify-content: center;
      border-radius: 50%;
    }

    .text {
      width: 85%;
      text-align: start;
    }
  }

  .text-input {
    width: 100%;
    resize: none;
  }
`;

const STATE = {
  isOpenAddModal: false,
  attRemarks: [],
  newRemarkText: '',
  editableRemark: null,
};
/* eslint-disable react/prefer-stateless-function */
class CompanyAttRemarksCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
    this.handleSave = this.handleSave.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleModalOpen = this.handleModalOpen.bind(this);
  }

  componentDidMount() {
    this.props.company?.attRemarks && this.setState({ attRemarks: JSON.parse(this.props.company?.attRemarks) });
    this.props.fetch();
  }

  get remarkDate() {
    return dayjs(new Date(Date.now())).format('DD-MM-YYYY HH:mm');
  }

  get sortingDate() {
    return new Date(Date.now());
  }

  handleModalOpen(remark = null) {
    this.setState({
      isOpenAddModal: true,
      editableRemark: remark?.id || null,
      newRemarkText: remark?.text || '',
    });
  }

  renderInitials(name, surname) {
    return (
      <HBox left vCenter>
        <HBox className="initials-wrapper" vCenter left>
          <strong>{name[0]?.toUpperCase()}</strong>
          <strong>{surname[0]?.toUpperCase()}</strong>
        </HBox>
        &nbsp;
        <strong>{name ?? ''}</strong>
        &nbsp;
        <strong>{surname ?? ''}</strong>
      </HBox>
    );
  }

  handleReset() {
    this.setState({
      isOpenAddModal: false,
      editableRemark: null,
      newRemarkText: '',
    });
  }

  onSave() {
    const remark = {
      id: Date.now(),
      text: this.state.newRemarkText,
      name: getPropByName(this.props.loggedUser, 'name'),
      surname: getPropByName(this.props.loggedUser, 'surname'),
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    const attRemarks = [...this.state.attRemarks, remark];

    this.props.setRemark(JSON.stringify(attRemarks), result => {
      if (result) {
        this.handleReset();
      }
    });
  }

  onEdit(remarkId) {
    const remark = {
      id: remarkId,
      text: this.state.newRemarkText,
      name: getPropByName(this.props.loggedUser, 'name'),
      surname: getPropByName(this.props.loggedUser, 'surname'),
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    const attRemarks = this.state.attRemarks?.filter(remark => remark?.id != remarkId);
    const updatedattRemarks = [...attRemarks, remark];

    this.props.setRemark(JSON.stringify(updatedattRemarks));
  }

  handleSave() {
    const { loggedUser, setRemark } = this.props;
    const { newRemarkText, attRemarks } = this.state;

    const remark = {
      id: Date.now(),
      userId: loggedUser?.id,
      text: newRemarkText,
      name: getPropByName(loggedUser, 'name'),
      surname: getPropByName(loggedUser, 'surname'),
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    const updatedRemarks = [...attRemarks, remark];

    this.props.setRemark(JSON.stringify(updatedRemarks), result => {
      if (result) {
        this.handleReset();
      }
    });
  }

  handleEdit(remarkId) {
    const { loggedUser, setRemark } = this.props;
    const { newRemarkText, attRemarks } = this.state;

    const remark = {
      id: remarkId,
      userId: loggedUser?.id,
      text: newRemarkText,
      name: getPropByName(loggedUser, 'name'),
      surname: getPropByName(loggedUser, 'surname'),
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    const filteredRemarks = attRemarks.filter(r => r?.id !== remarkId);
    const updatedRemarks = [...filteredRemarks, remark];

    setRemark(JSON.stringify(updatedRemarks));
    this.handleReset();
  }

  handleDelete(remarkId) {
    const { setRemark } = this.props;
    const { attRemarks } = this.state;

    const updatedRemarks = attRemarks.filter(remark => remark?.id !== remarkId);
    setRemark(JSON.stringify(updatedRemarks));
  }

  renderAddModal() {
    return (
      <ModalComponent
        title={this.state.editableRemark ? this.lbl('info.remarks.edit') : this.lbl('info.remarks.add')}
        onClose={this.handleReset}
      >
        <Textarea
          className="text-input"
          value={this.state.newRemarkText}
          onChange={e => this.setState({ newRemarkText: e.target?.value })}
        />

        <div className="d-flex gap-2 mt-2 justify-content-center">
          <ButtonComponent
            style={'ButtonSoftEdit'}
            disabled={this.props.work}
            onClick={this.state.editableRemark ? () => this.handleEdit(this.state.editableRemark) : this.handleSave}
          >
            {this.state.editableRemark ? this.lbl('confirm') : this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.handleReset}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  render() {
    if (this.props.work) return <Loader small />;
    const nl2br = text => {
      return { __html: text?.replace(/(?:\r\n|\r|\n)/g, '<br>') };
    };
    return (
      <Card className="vehicle-info-card info-card data">
        <Container>
          {this.state.isOpenAddModal && this.renderAddModal(this.state.isEdit)}
          <HBox>
            <h2>{this.lbl('info.attremarks.title')}</h2>
            <ButtonComponent
              style={'ButtonSoftPrimary'}
              size={'btn-sm'}
              onClick={() => this.setState({ isOpenAddModal: true })}
            >
              {this.lbl('info.remarks.add')}
            </ButtonComponent>
          </HBox>
          <List>
            {this.state.attRemarks
              ?.sort((a, b) => ((b?.sortingDate ?? b.date) < (a?.sortingDate ?? a.date) ? -1 : 1))
              ?.map(remark => (
                <Row key={remark?.id}>
                  <div className={styles.remarkCard}>
                    <HBox className="gap-2" vCenter right>
                      <ButtonComponent
                        style={'ButtonSoftEdit'}
                        disabled={env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id}
                        size={'btn-sm'}
                        onClick={() => {
                          if (env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id) {
                            return;
                          }
                          this.handleModalOpen(remark);
                        }}
                      >
                        <Edit />
                      </ButtonComponent>
                      <ButtonComponent
                        style={'ButtonSoftDelete'}
                        disabled={env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id}
                        size={'btn-sm'}
                        onClick={() => {
                          if (env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id) {
                            return;
                          }
                          this.handleDelete(remark?.id);
                        }}
                      >
                        <Times />
                      </ButtonComponent>
                    </HBox>
                    <VBox className="remark" vCenter>
                      {remark?.name && remark?.surname && this.renderInitials(remark?.name, remark?.surname)}
                      <div className={styles.remarkText}>
                        <pre>
                          <h6 style={{ color: 'red' }}>{remark?.text}</h6>
                        </pre>
                      </div>
                    </VBox>
                    <HBox right>{remark?.date}</HBox>
                  </div>
                </Row>
              ))}
          </List>
        </Container>
      </Card>
    );
  }
}

CompanyAttRemarksCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_USER, `${REQUEST_COMPANY_PROPERTY_UPDATE}-attRemarks`, REQUEST_COMPANY_PROPERTY_UPDATE]),
    loggedUser: selectUser(ownProps?.loggedUserId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchUser(ownProps?.loggedUserId));
    },
    setRemark(dto, callback) {
      dispatch(setCompanyProperty(ownProps?.company?.id, 'attRemarks', dto, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyAttRemarksCard = compose(withConnect, withRouter)(CompanyAttRemarksCardComp);
